__turbopack_context__.v({
  "auctionsLink": "dropAuction-module-scss-module__eloTAG__auctionsLink",
  "containerTop": "dropAuction-module-scss-module__eloTAG__containerTop",
  "dropLanding": "dropAuction-module-scss-module__eloTAG__dropLanding",
  "dropLandingBrand": "dropAuction-module-scss-module__eloTAG__dropLandingBrand",
  "dropLandingImg": "dropAuction-module-scss-module__eloTAG__dropLandingImg",
  "landBrandBox": "dropAuction-module-scss-module__eloTAG__landBrandBox",
  "landBrandBoxInner": "dropAuction-module-scss-module__eloTAG__landBrandBoxInner",
  "landBrandBoxLt": "dropAuction-module-scss-module__eloTAG__landBrandBoxLt",
  "landBrandBoxRt": "dropAuction-module-scss-module__eloTAG__landBrandBoxRt",
  "modifyBtn": "dropAuction-module-scss-module__eloTAG__modifyBtn",
  "moneyIcon": "dropAuction-module-scss-module__eloTAG__moneyIcon",
  "seeBtnAction": "dropAuction-module-scss-module__eloTAG__seeBtnAction",
  "seeMore": "dropAuction-module-scss-module__eloTAG__seeMore",
  "seeMoreSmall": "dropAuction-module-scss-module__eloTAG__seeMoreSmall",
  "watchAut": "dropAuction-module-scss-module__eloTAG__watchAut",
  "watchAutTxt": "dropAuction-module-scss-module__eloTAG__watchAutTxt",
});
